import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import '../styles/NotFound.css';

const NotFound = () => {
  useEffect(() => {
    // Update page title
    document.title = '404 - Strona nie znaleziona | Mespi.dev';
  }, []);

  return (
    <div className="App">
      <Navigation />
      <section className="not-found-section">
        <div className="container">
          <div className="not-found-content">
            <div className="error-code">404</div>
            <h1 className="error-title">Ups! Strona nie została znaleziona</h1>
            <p className="error-description">
              Wygląda na to, że strona, której szukasz, nie istnieje lub została przeniesiona.
              Może chcesz wrócić do strony głównej?
            </p>
            <div className="error-actions">
              <Link to="/" className="btn-primary">
                Wróć do strony głównej
              </Link>
              <Link to="/projekty" className="btn-secondary">
                Zobacz nasze projekty
              </Link>
            </div>
            <div className="error-animation">
              <div className="floating-element">🔍</div>
              <div className="floating-element delay-1">📄</div>
              <div className="floating-element delay-2">❓</div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default NotFound;
